import Tick from '@/assets/icons/tick.svg';
import UKDrawer from '@/components/UKDrawer';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/30451';
import {
  EXPOSURE_RECORD as HOME_CHANNEL_PAGE_EXPOSURE_RECORD,
  sendClickTrack as HOME_CHANNEL_PAGE_sendClickTrack,
} from '@/tracks/32398';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import { useState } from 'react';
import { MentalObjectType } from '..';
import styles from './mental.module.scss';
interface Props {
  mentalRef: any;
  disabled?: boolean;
  isShowMental?: boolean;
  mentalTop?: number;
  mentalObject?: MentalObjectType;
  homeMentalObject?: MentalObjectType;
  currentTab?: string;
  pageName?: string;
}
const Mental = ({
  mentalRef,
  disabled,
  isShowMental,
  mentalTop,
  mentalObject,
  homeMentalObject,
  currentTab,
  pageName,
}: Props) => {
  const { type, mentalList, modelTitle, modelRichText } = mentalObject || {};
  const { mentalList: homeMentalList } = homeMentalObject || {};
  // const mentalList = ['30-day return','30-day return']
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(true);
  };

  if (!mentalList || mentalList?.length === 0) return null;

  return (
    <>
      {isShowMental && (
        <div
          className={`
        ${styles.ceilingWrap}
        ${disabled ? styles.disabled : ''}
        ${type === 'normal' ? styles.normal : ''}
      `}
          style={{ top: `${mentalTop}px` }}
          onClick={handleClick}
        >
          {mentalList.map((item: string) => (
            <div
              className={styles.mentalItem}
              key={item}
              data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
              data-exp={JSON.stringify({
                spm: 'a0145.b002218.c00002477.platform_mental',
                event_id: 'Home_Platform_Mind_Expo',
                page_id: 'Home_Main',
                json_param: {
                  title: item,
                  // @ts-ignore
                  styleType: type === 'normal' ? '2' : '3',
                  tab_name: currentTab || '-1',
                  Mini_Hp_Name: pageName,
                },
              })}
              onClick={() => {
                spmTrackingUtils.spmClick({
                  spm: 'a0145.b002218.c00002477.platform_mental',
                  event_id: 'Home_Platform_Mind',
                  page_id: 'Home_Main',
                  json_param: JSON.stringify({
                    title: item,
                    // @ts-ignore
                    styleType: type === 'normal' ? '2' : '3',
                    tab_name: currentTab || '-1',
                    Mini_Hp_Name: pageName,
                  }),
                });
              }}
            >
              <Tick className={styles.tick} width={12} height={10} />
              {item}
            </div>
          ))}
        </div>
      )}
      <div
        ref={mentalRef}
        className={`${styles.mentalWrap} ${disabled ? styles.disabled : ''}`}
        onClick={handleClick}
      >
        {homeMentalList?.map((item: string) => (
          <div
            className={styles.mentalItem}
            key={item}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            data-exp={JSON.stringify({
              spm: 'a0145.b002218.c00002477.platform_mental',
              event_id: 'Home_Platform_Mind_Expo',
              page_id: 'Home_Main',
              json_param: {
                title: item,
                // @ts-ignore
                styleType: type === 'normal' ? '2' : '3',
                tab_name: currentTab || '-1',
                Mini_Hp_Name: pageName,
              },
            })}
            onClick={() => {
              spmTrackingUtils.spmClick({
                spm: 'a0145.b002218.c00002477.platform_mental',
                event_id: 'Home_Platform_Mind',
                page_id: 'Home_Main',
                json_param: JSON.stringify({
                  title: item,
                  // @ts-ignore
                  styleType: type === 'normal' ? '2' : '3',
                  tab_name: currentTab || '-1',
                  Mini_Hp_Name: pageName,
                }),
              });
            }}
          >
            <Tick className={styles.tick} width={12} height={10} />
            {item}
          </div>
        ))}
      </div>
      <UKDrawer title={modelTitle} openDrawer={isOpen} setOpenDrawer={setIsOpen} height='75vh'>
        {mentalList.map((item: string, index: number) => {
          return (
            <div className={styles.modelItem} key={item}>
              <div className={styles.subTitle}>{item}</div>
              {modelRichText && modelRichText[index] && (
                <div
                  className={styles.richText}
                  dangerouslySetInnerHTML={{ __html: modelRichText[index] }}
                ></div>
              )}
            </div>
          );
        })}
      </UKDrawer>
    </>
  );
};
export default Mental;
